// taskDetail.tips_fields token -> column label, key on the employee rows, key on the
// location/company summaries. Mirrors HoursImportTask.TIPS_FIELD_COLUMNS (ess/models.py).
const TIPS_COLUMNS = {
    tips: {label: 'Tips', rowKey: 'Tips_Amt', totalKey: 'total_tips'},
    cash_tips: {label: 'Cash Tips', rowKey: 'Cash_Tips_Amt', totalKey: 'total_cash_tips'},
    charged_tips: {label: 'Charged Tips', rowKey: 'Charged_Tips_Amt', totalKey: 'total_charged_tips'},
}

export function tipsColumns(taskDetail) {
    return (taskDetail.tips_fields || [])
        .filter(field => TIPS_COLUMNS[field])
        .map(field => ({id: field, ...TIPS_COLUMNS[field]}))
}

// The "big metric" for total_other_earnings, or null when there's nothing to show.
// With tips columns the total is summed from those columns alone, so it can say "Tips".
export function otherEarningsTile(taskDetail) {
    const amount = taskDetail.payroll_summary_stats.total_other_earnings
    if (!(Number(amount) > 0)) {
        return null
    }

    return {
        label: tipsColumns(taskDetail).length ? 'Tips' : 'Other Earnings',
        amount: amount,
    }
}
